<template>
    <div class="vc-checkout-container">
        <div class="vc-checkout-coupon" style="margin-left:auto;">
            <base-control :errorMsg="null"
                        :errorWithIcon="true"
                        :small="true"
                        :state="state"
                        :successMsg="null"
                        :successWithIcon="true"
                        @keyup="resetError"
                        autocomplete="off"
                        class="vc-checkout-coupon__field"
                        id="checkout-coupon-code"
                        label="Coupon Code"
                        type="text"
                        v-model="code">
            </base-control>
            <button :disabled="couponLoading"
                    @click="hasCoupon ? removeCoupon(): addCoupon()"
                    class="vc-checkout-coupon__button c-button c-button--default">
                {{hasCoupon ? 'Remove': 'Apply'}}
            </button>
        </div>
        <div class="vc-checkout-coupon__msg">
            <span v-if="errorMsg!==null" class="vc-checkout-coupon__msg--error">{{errorMsg}}</span>
            <span v-if="successMsg!==null" class="vc-checkout-coupon__msg--success">{{successMsg}}</span>
        </div>
    </div>
</template>

<script>
    import Coupons from './../../mixins/coupons.vue'

    export default {
        name: "checkout-coupon",
        data() {
            return {
                couponApplied: false,
            }
        },
        mixins: [
            Coupons
        ],
        computed: {
            cart() {
                return this.$store.state.cart;
            },
            hasCoupon() {
                return this.cart.couponApplied;
            },
            couponLoading() {
                return this.$store.state.coupon.loading;
            },
            errorMsg() {
                return this.message || null; // from Coupons mixin
            },
            successMsg() {
                return this.discountString || null; // from Coupons mixin
            },
            state() {
                if (this.couponLoading)
                    return 'processing';
                else if (this.error && this.errorMsg)
                    return 'error';
                else if (this.cart.couponApplied && this.successMsg)
                    return 'success';
                else
                    return 'info';
            },
        },
        methods: {
            addCoupon() {
                this.cart.unsetCoupon();
                this.getCoupon();
            },
            removeCoupon() {
                this.cart.unsetCoupon();

                this.$store.commit("coupon", {
                    error: false,
                    discountString: false,
                    code: ""
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
    .vc-checkout-container{
        display: flex;
        flex-direction: row-reverse;
        -webkit-flex-direction: row-reverse; 
        @media screen and (max-width: 870px){
            display: block;
        }
    }
    .vc-checkout-coupon {
        display: flex;
        justify-content: flex-end;
        &__field {
            flex-basis: 225px;
            min-width: 150px;
        }

        &__button {
            margin-left: 12px;
            flex-basis: 75px;
        }

        &__msg{
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 600;
            margin-right:10px;
            @media screen and (max-width: 870px){
                display: block;
                width: 100%;
                margin-top:10px;
            }
            &--error{
                color: var(--error-color);
            }
            &--success{
                color: var(--success-color);
            }
        }

        @media screen and (max-width: 870px){
            display: grid;
            grid-template-columns: 1fr 0fr;
        }
    }
</style>